import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function IntervalTable({ intervals, setIntervals }) {
  const handleFieldChange = (index, field, value) => {
    const updatedIntervals = [...intervals];
    if (field === 'start_date' || field === 'end_date') {
      updatedIntervals[index][field] = value ? dayjs(value).format('YYYY-MM-DD') : '';
    } else {
      updatedIntervals[index][field] = value;
    }
    setIntervals(updatedIntervals);
  };

  const addNewRow = () => {
    setIntervals([
      ...intervals,
      { client_id: '', filename: '', start_date: '', end_date: '' }
    ]);
  };

  const removeRow = (index) => {
    const updated = intervals.filter((_, i) => i !== index);
    setIntervals(updated);
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Client ID</TableCell>
            <TableCell>Filename</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Remove</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {intervals.map((interval, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  value={interval.client_id || ''}
                  onChange={(e) => handleFieldChange(index, 'client_id', e.target.value)}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={interval.filename || ''}
                  onChange={(e) => handleFieldChange(index, 'filename', e.target.value)}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <DatePicker
                  label="Start Date"
                  value={interval.start_date ? dayjs(interval.start_date) : null}
                  onChange={(newValue) => handleFieldChange(index, 'start_date', newValue)}
                  format="YYYY-MM-DD"
                  slotProps={{ textField: { size: 'small' } }}
                />
              </TableCell>
              <TableCell>
                <DatePicker
                  label="End Date"
                  value={interval.end_date ? dayjs(interval.end_date) : null}
                  onChange={(newValue) => handleFieldChange(index, 'end_date', newValue)}
                  format="YYYY-MM-DD"
                  slotProps={{ textField: { size: 'small' } }}
                />
              </TableCell>
              <TableCell>
                <Button variant="outlined" size="small" onClick={() => removeRow(index)}>
                  Remove
                </Button>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={5} align="center">
              <Button variant="contained" onClick={addNewRow}>
                Add New Interval
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
